export class Resp {
    constructor(
            public status: number = 200,
            public rslt: number = 1,
            public msg: string = '',
            public data: any = null) { }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/resp.ts